import axios from 'axios';
/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */
window.axios = axios;
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
let token = document.head.querySelector('meta[name="csrf-token"]').content;
if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token;
}
else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}
// Ajax通信 開始イベント
window.axios.interceptors.request.use(function (config) {
    lock();
    window.dispatchEvent(new CustomEvent('ajaxSend'));
    return config;
}, function (error) {
    unlock();
    window.dispatchEvent(new CustomEvent('ajaxComplete'));
    return Promise.reject(error);
});
// Ajax通信 終了イベント
window.axios.interceptors.response.use(function (response) {
    unlock();
    window.dispatchEvent(new CustomEvent('ajaxComplete'));
    return response;
}, function (error) {
    unlock();
    window.dispatchEvent(new CustomEvent('ajaxComplete'));
    return Promise.reject(error);
});
window.axios.prototype.requested = 0;
window.axios.prototype.requested_max = 0;
function lock() {
    window.axios.prototype.requested++;
    window.axios.prototype.requested_max++;
    if (window.axios.prototype.requested <= 0)
        return;
    const element = document.querySelector('#__spinner');
    if (element) {
        element.classList.add('__lock');
    }
}
function unlock() {
    window.axios.prototype.requested--;
    if (window.axios.prototype.requested <= 0) {
        window.axios.prototype.requested = 0;
        window.axios.prototype.requested_max = 0;
        const element = document.querySelector('#__spinner');
        if (element) {
            element.classList.remove('__lock');
        }
    }
}
